// @flow

import Game from '@/lib/game';

// 極相林が完成したことを伝えるメッセージ
export default class {
  static isSatisfied(game: Game): boolean {
    const {
      beechAdultTreesCount,
      cedarAdultTreesCount,
      mapleAdultTreesCount,
      zelkovaAdultTreesCount,
      creAdultTreesCount,
      cherryAdultTreesCount,
    } = game.stats;

    const shadeTreesCount =
      beechAdultTreesCount + cedarAdultTreesCount + mapleAdultTreesCount;
    const sunTreesCount =
      zelkovaAdultTreesCount + creAdultTreesCount + cherryAdultTreesCount;

    const treesCount = sunTreesCount + shadeTreesCount;
    const shadeTreesRate = shadeTreesCount / treesCount;

    return treesCount >= 20 && shadeTreesRate >= 0.6;
  }

  static makeMessage() {
    return {
      uid: 'sun_tree',
      priority: 30,
      title: '植生が極相林に遷移しました',
      body: `クリやケヤキなど「陽樹」と呼ばれる樹種は、明るい環境で速く成長します。しかし、これらが大きく育って森林ができると、地表に届く光が少なくなって陽樹の芽生えは生育しにくくなります。
すると、暗い環境でも成長ができるブナやスギなどの「陰樹」と呼ばれる樹種が侵入します。陽樹が枯死した場合、次に大きく成長するのは陰樹であり、陰樹を主とした森林になります。
このような植物種の移り変わりを「遷移」と呼びます。陰樹の森林が形成されると陰樹が枯死したあとに成長してくる樹種はやはり陰樹が多く、これ以上遷移が進むことはありません。このような状態を極相(クライマックス)と呼びます。`,
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/tutorial_event/shade_tree.js